__turbopack_context__.v({
  "header": "ProfileInfo-module-scss-module__KEIPzW__header",
  "input": "ProfileInfo-module-scss-module__KEIPzW__input",
  "inputContainer": "ProfileInfo-module-scss-module__KEIPzW__inputContainer",
  "personalInfo": "ProfileInfo-module-scss-module__KEIPzW__personalInfo",
});
